// #standard page
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setActivePage } from '../../redux/actions';

import PageTitle from '../../components/PageTitle';

//#form
import {
    Row,
    Col,
    Card,
    CardBody,
    Table,
    Nav,
    NavItem,
    NavLink,
    Alert
} from 'reactstrap';

//#other
import classnames from 'classnames';
import { fetchJSON } from '../../helpers/api';
import GenericTable from '../../components/GenericTable';

import InfoBanner from "./InfoBanner";


const columns = [
    {
        dataField: 'claimRef',
        text: 'Claim No.',
        sort: true
    },
    {
        dataField: 'eventTypeDescription',
        text: 'Claim Type',
        sort: true

    },
    {
        dataField: 'modelType',
        text: 'Model',
        sort: true
    },
    {
        dataField: 'parentMSN',
        text: 'Serial No.',
        sort: true
    },
    {
        dataField: 'parentRegistration',
        text: 'Reg No.',
        sort: true
    },
    {
        dataField: 'msnRef',
        text: 'Component Serial No.',
        sort: true
    },
    {
        dataField: 'customerClaimStatus',
        text: 'Claim Status',
        sort: true
    },
    {
        dataField: 'claimDate',
        text: 'Event Date',
        sort: true
    },
];


const columnsSummary = [
    {
        dataField: 'partyName',
        text: 'Lessee',
        sort: true
    },
    {
        dataField: 'eventTypeDescription',
        text: 'Claim Type',
        sort: true

    },
    {
        dataField: 'modelType',
        text: 'Model',
        sort: true
    },
    {
        dataField: 'parentMSN',
        text: 'Serial No.',
        sort: true
    },
    {
        dataField: 'parentRegistration',
        text: 'Reg No.',
        sort: true
    },
    {
        dataField: 'msnRef',
        text: 'Component Serial No.',
        sort: true
    },
    {
        dataField: 'customerClaimStatus',
        text: 'Claim Status',
        sort: true
    },
    {
        dataField: 'claimDate',
        text: 'Event Date',
        sort: true,
        style: { whiteSpace: 'nowrap' }
    }    
];


const defaultSorted = [
    {
        dataField: 'claimRef',
        order: 'desc',
    },
];



class ClaimsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            claimsData: [],
            claimsloading: true,
            error: false,
            tabHeadings: [],
            activeTab: '0',
            columns: columns
        };

        this.loadClaims = this.loadClaims.bind(this);
        this.getExpandedRows = this.getExpandedRows.bind(this);

    }

    componentDidMount = () => {
        this.props.setActivePage();

        this.loadClaims();
    }

    async loadClaims() {
        let url = `/portal/Claims/GetClaims`;
        let response = await fetchJSON(url);
        let lessees = [...new Set(response.data.map(({ partyName }) => partyName))];
        this.setState({
            claimsData: response.data,
            claimsloading: response.loading,
            error: response.error,
            tabHeadings: [...lessees]
        });

        // multiple tabs (serviced entities)
        if (lessees.length > 1) {
            this.setState({
                columns: columnsSummary,
            });
        }
    }


    /**
    * Toggle the tab
    */
    toggle = (tab: string) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                columns: tab === "0" ? columnsSummary : columns
            });
        }
    };

    getExpandedRows() {
        const selectedClaim = this.props.history.location.state?.selectedClaim;
        if (selectedClaim != null) {
            return [selectedClaim]
        }
        return [];
    }
   
    expandRow = {
        renderer: claim => (
            <ClaimDetails ClaimRef={claim.claimRef} />
        ),
        expanded: this.getExpandedRows()
    };

    render() {    
        return (
            <React.Fragment>
                <PageTitle
                    breadCrumbItems={[
                        { label: 'Claims', path: '/SupplementalRent/Claims', active: true },
                    ]}
                    title={'Claims'}
                    error={this.state.error}
                />

                <InfoBanner />
                
                <Card>
                    <CardBody>
                        <React.Fragment>
                            {/* Single party */}
                            {this.state.tabHeadings.length <= 1 && (
                                <GenericTable
                                    columns={columns}
                                    data={this.state.claimsData}
                                    keyField='claimRef'
                                    defaultSorted={defaultSorted}
                                    loading={this.state.claimsloading}
                                    exportListName='Claims'
                                    expandRow={this.expandRow}
                                />
                            )}

                            {/* Multiple parties */}
                            {this.state.tabHeadings.length > 1 && (
                                <React.Fragment>
                                    <Nav tabs className="nav-bordered">
                                        {this.state.tabHeadings.map((tab, index) => {
                                            return (
                                                <NavItem key={index}>
                                                    <NavLink
                                                        href="#"
                                                        className={classnames({ active: this.state.activeTab === index.toString() }, { 'bg-light-lighten': index === 0 })}
                                                        onClick={() => {
                                                            this.toggle(index.toString());
                                                        }}>
                                                        <span>{tab}</span>
                                                    </NavLink>
                                                </NavItem>
                                            );
                                        })}
                                    </Nav>

                                    <br />
                                    <GenericTable
                                        columns={this.state.columns}
                                        data={this.state.claimsData.filter(l => (this.state.activeTab === "0" && l.partyName !== this.state.tabHeadings[this.state.activeTab]) || (this.state.activeTab !== "0" && l.partyName === this.state.tabHeadings[this.state.activeTab]))}
                                        keyField='claimRef'
                                        defaultSorted={defaultSorted}
                                        loading={this.state.claimsloading}
                                        exportListName='Claims'
                                        expandRow={this.expandRow}
                                    />
                                </React.Fragment>
                            )}

                        </React.Fragment>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

class ClaimDetails extends Component {
    constructor(props) {
        super(props);
        this.state = { claimsDetailsData: [], claimsDetailsloading: true };

        this.loadClaimDetails = this.loadClaimDetails.bind(this);
    }

    componentDidMount = () => {
        this.loadClaimDetails();
    }

    async loadClaimDetails() {
        let url = `/portal/Claims/GetClaimDetails?claimRef=${this.props.ClaimRef}`;
        let response = await fetchJSON(url);
        this.setState({ claimsDetailsData: response.data, claimsDetailsloading: response.loading });
    }

    render() {
        return (
            <React.Fragment>
                <Card className="expand-row">
                    <CardBody>
                        <Row className="mr-1">
                            <Col xs={12} sm={6} lg={4} xl={4} >
                                <Card className="mb-0 d-block">
                                    <CardBody className="position-relative mb-0">
                                        <h4 className="mt-0 text-title">Event Details</h4>
                                        <Table size="sm" className="mb-0" responsive>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Claim No.</strong></td>
                                                    <td>{this.state.claimsDetailsData.claimRef}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Claim Status</strong></td>
                                                    <td>{this.state.claimsDetailsData.customerClaimStatus}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Event Description</strong></td>
                                                    <td>{this.state.claimsDetailsData.eventDescription}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Facility</strong></td>
                                                    <td>{this.state.claimsDetailsData.facility}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Location</strong></td>
                                                    <td>{this.state.claimsDetailsData.location}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>TSN</strong></td>
                                                    <td>{this.state.claimsDetailsData.tsn}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>CSN</strong></td>
                                                    <td>{this.state.claimsDetailsData.csn}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col xs={12} sm={6} lg={4} xl={4} >
                                <Card className="mb-0 d-block">
                                    <CardBody className="position-relative mb-0">
                                        <h4 className="mt-0 text-title">Airline / Customer Contact Person</h4>
                                        <Table size="sm" className="mb-0" responsive>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Contact Name</strong></td>
                                                    <td>{this.state.claimsDetailsData.contactName}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Contact Email</strong></td>
                                                    <td>{this.state.claimsDetailsData.contactEmail}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col xs={12} sm={6} lg={4} xl={4} >
                                <Card className="mb-0 d-block">
                                    <CardBody className="position-relative mb-0">
                                        <h4 className="mt-0 text-title">Settlement Details</h4>
                                        <Table size="sm" className="mb-0" responsive>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Settled Date</strong></td>
                                                    <td> {this.state.claimsDetailsData.settledDate}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Claimed Amount</strong></td>
                                                    <td>{this.state.claimsDetailsData.claimedAmountUSD}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Total Approved</strong></td>
                                                    <td>{this.state.claimsDetailsData.settledAmountUSD}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Airline Bank</strong></td>
                                                    <td>{this.state.claimsDetailsData.bankName}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>US Clearing Bank</strong></td>
                                                    <td>{this.state.claimsDetailsData.usclearingBank}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>ABA No.</strong></td>
                                                    <td>{this.state.claimsDetailsData.abaNo}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setActivePage: () => {
            dispatch(setActivePage("SuppRent_Claims"));
        }
    };
}

export default withRouter(
    connect(null, mapDispatchToProps)(ClaimsList)
);
